import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-gear';
export var ID = 'icon-gear';
/* eslint-disable max-len */

export var SVGGear = function SVGGear() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("defs", null, React.createElement("path", {
    d: "M8,10.75 C6.48,10.75 5.25,9.519 5.25,8 C5.25,6.481 6.48,5.25 8,5.25 C9.519,5.25 10.75,6.481 10.75,8 C10.75,9.519 9.519,10.75 8,10.75 M14.305,7.161 L13.551,7.017 C13.107,6.932 12.745,6.63 12.58,6.209 C12.414,5.789 12.476,5.321 12.743,4.957 L13.216,4.312 C13.286,4.217 13.276,4.084 13.191,3.999 L12.171,2.978 C12.089,2.896 11.961,2.885 11.865,2.949 L11.23,3.379 C10.856,3.633 10.387,3.676 9.973,3.495 C9.559,3.314 9.271,2.939 9.202,2.494 L9.08,1.703 C9.062,1.587 8.962,1.5 8.842,1.5 L7.398,1.5 C7.283,1.5 7.184,1.582 7.161,1.695 L6.974,2.669 C6.891,3.103 6.598,3.462 6.19,3.63 C5.782,3.8 5.32,3.752 4.954,3.506 L4.134,2.949 C4.039,2.885 3.911,2.896 3.829,2.979 L2.808,3.999 C2.724,4.084 2.714,4.217 2.783,4.312 L3.256,4.957 C3.524,5.321 3.584,5.789 3.419,6.21 C3.255,6.63 2.892,6.932 2.448,7.017 L1.694,7.162 C1.582,7.184 1.5,7.283 1.5,7.398 L1.5,8.842 C1.5,8.961 1.587,9.063 1.704,9.081 L2.494,9.202 C2.94,9.271 3.314,9.558 3.494,9.973 C3.676,10.387 3.632,10.857 3.379,11.23 L2.949,11.865 C2.885,11.961 2.896,12.089 2.979,12.172 L3.999,13.192 C4.083,13.276 4.216,13.287 4.312,13.217 L4.957,12.744 C5.321,12.478 5.789,12.415 6.209,12.58 C6.63,12.745 6.932,13.108 7.017,13.552 L7.161,14.305 C7.184,14.419 7.283,14.5 7.398,14.5 L8.842,14.5 C8.962,14.5 9.063,14.413 9.08,14.297 L9.165,13.74 C9.235,13.283 9.532,12.906 9.959,12.729 C10.386,12.553 10.861,12.611 11.234,12.884 L11.688,13.217 C11.783,13.287 11.916,13.276 12.001,13.191 L13.021,12.172 C13.104,12.089 13.115,11.961 13.051,11.865 L12.62,11.23 C12.367,10.857 12.324,10.387 12.505,9.973 C12.685,9.558 13.059,9.271 13.505,9.202 L14.295,9.081 C14.413,9.063 14.5,8.961 14.5,8.842 L14.5,7.398 C14.5,7.283 14.419,7.184 14.305,7.161",
    id: "gear-path"
  })), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Icon/Glyph/Customize"
  }, React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#gear-path"
  })), React.createElement("use", {
    id: "Mask",
    xlinkHref: "#gear-path",
    fill: "grey"
  }))));
};
/* eslint-disable max-len */

var Gear = function Gear(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGGear
  });
};

Gear.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Gear;